import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiAppNoDataModule } from '../../_ui/ui-app-no-data/ui-app-no-data.module';
import { UiControlQuestionsComponent } from './ui-control-questions.component';
import { UiTooltipModule } from '../../_ui/ui-tooltip/ui-tooltip.module';
import { PipesModule } from '../../app.pipes.module';
import { AppTranslocoModule } from '../../app.transloco.module';
import { UiPaginationModule } from '../../_ui/ui-pagination/ui-pagination.module';

@NgModule({
  declarations: [UiControlQuestionsComponent],
  exports: [UiControlQuestionsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: UiControlQuestionsComponent,
        children: [],
      },
      {
        path: ':category',
        component: UiControlQuestionsComponent,
      },
    ]),
    UiAppNoDataModule,
    UiTooltipModule,
    PipesModule,
    AppTranslocoModule,
    UiPaginationModule,
  ],
})
export class UiControlQuestionsModule {}
